import { render, staticRenderFns } from "./page-book-session-copy.vue?vue&type=template&id=600da1fa"
import script from "./page-book-session-copy.vue?vue&type=script&lang=js"
export * from "./page-book-session-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports